import { UTCDate } from '@/utils/dates';
import { useState } from 'react';
import { useData } from '../../../../contexts/data-context/use-data';
import { LoadingSection } from '../../../../design-system/loading/loading';
import { Stack } from '../../../../design-system/stack/stack';
import { ReportingDataTableWrapper } from '../../components/data-table-components/reporting-data-table-wrapper';
import CashFlowMetrics from './cash-flow-metrics';
import { CashFlowMoneyMovement } from './cash-flow-money-movement';

const CashFlowWrapper = () => {
  const { data, isLoading, error } = useData();
  const [referenceDate, setReferenceDate] = useState(new UTCDate());
  const [highlightedMonth, setHighlightedMonth] = useState(new UTCDate());

  if (isLoading) {
    return <LoadingSection text="Creating your cash flow report..." />;
  }

  if (!data || error) {
    return <div>No data</div>;
  }

  const { accounts } = data;

  return (
    <Stack className="mx-6 mb-10" space={10}>
      <CashFlowMetrics accounts={accounts} baseCurrency={data.baseCurrency} />
      <div className="w-full rounded-lg border-[0.5px] border-border bg-white">
        <CashFlowMoneyMovement
          accounts={accounts}
          categories={data.categories}
          baseCurrency={data.baseCurrency}
          referenceDate={referenceDate}
          onReferenceDateChange={(date) => {
            setReferenceDate(new UTCDate(date));
            setHighlightedMonth(new UTCDate(date));
          }}
          highlightedMonth={highlightedMonth}
          onHighlightedMonthChange={(date) => setHighlightedMonth(new UTCDate(date))}
        />
        <ReportingDataTableWrapper referenceDate={referenceDate} highlightedMonth={highlightedMonth} />
      </div>
    </Stack>
  );
};

export default CashFlowWrapper;
